import React from 'react';

interface LoadingIconProps {
  className?: string;
}

const LoadingIcon: React.FC<LoadingIconProps> = ({ className = 'h-5 w-5 text-[#E2E5E8]' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={className}
      fill="currentColor"
    >
      <circle cx="50" cy="50" r="45" stroke="#E2E5E8" strokeWidth="10" fill="none" />
      <circle cx="50" cy="50" r="35" stroke="#E2E5E8" strokeWidth="10" fill="none" />
      <circle cx="50" cy="50" r="25" stroke="#E2E5E8" strokeWidth="10" fill="none" />
      <circle cx="50" cy="50" r="15" stroke="#E2E5E8" strokeWidth="10" fill="none" />
      <circle cx="50" cy="50" r="5" stroke="#E2E5E8" strokeWidth="10" fill="none" />
    </svg>
  );
};

export default LoadingIcon;
